import Select from "react-select";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { customStyles } from "../../../../helpers/modal_styles";
import "./MembresiaEditModal.css";
import { useDispatch } from "react-redux";
import Moment from "moment";
import { onEditarImpuesto } from "../../../../services/impuestos/impuestos";

export const MembresiaEditModal = ({
  setmodalEditar,
  modalEditar,
  editar,
  state,
  setState,
  tiposMembresia = [],
}) => {
  const dispatch = useDispatch();
  Modal.setAppElement("#root");


  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    if (editar && editar.id) {
      const initialState = {
        id: editar.id,
        email: editar.email,
        fechaVencimiento: editar.fechaVencimiento,
        idMembresia: editar.idMembresia,
        membresia: editar.membresia,
      };
      setFormValues(initialState);
    }
  }, [editar]);

  // Generar opciones del Select desde tiposMembresia
  const generateSelectOptions = () => {
    return tiposMembresia.map(tipo => ({
      value: tipo.id.toString(),
      label: `${tipo.membresia} (Clientes: ${tipo.max_clientes}, Auxiliares: ${tipo.max_auxiliares})`
    }));
  };

  // Encontrar la opción seleccionada actualmente
  const getCurrentSelectOption = () => {
    if (!formValues.idMembresia) return null;
    const options = generateSelectOptions();
    return options.find(opt => opt.value === formValues.idMembresia.toString());
  };

  //FUNCTION========================
  const closeModal = () => {
    setmodalEditar(false);
  };

  const editarModel = async (e) => {
    e.preventDefault();
    
    try {
      const respuesta = await dispatch(
        onEditarImpuesto(
          formValues.id,
          formValues.idMembresia,
          Moment(formValues.fechaVencimiento).locale("es_CO").format("YYYY-MM-DD h:mm:ss"),
        )
      );

      // Verificar si hubo error en la respuesta
      if (respuesta && respuesta.msg) {
        // Hay un mensaje de error
        Swal.fire('Error', respuesta.msg, 'error');
      } else if (respuesta && respuesta.errors) {
        // Hay errores de validación
        const errorMsg = respuesta.errors[0]?.msg || 'Error al guardar los cambios';
        Swal.fire('Error', errorMsg, 'error');
      } else {
        // Éxito
        Swal.fire('Éxito', 'Membresía actualizada correctamente', 'success');
        closeModal();
      }
    } catch (error) {
      console.log('Error:', error);
      Swal.fire('Error', 'Error al guardar los cambios', 'error');
    }
  };

  //FIN FUNCTION========================

  return (
    <Modal
      isOpen={modalEditar}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="popup">
        <center>
          <h3>Editar Membresia</h3>
        </center>
        <br />
        <form onSubmit={editarModel}>
          <div className="form-row">
            <div className="form-grupin col-md-12">
              <h6>Fecha Vencimiento</h6>
              <input
                placeholder=""
                type="date"
                name="membresia"
                className="form-control"
                value={Moment(formValues.fechaVencimiento).format("YYYY-MM-DD")}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    fechaVencimiento: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="form-row">
            <div className=" form-grupin col-md-12">
              <label>Tipo de Membresía</label>
              <Select
                options={generateSelectOptions()}
                value={getCurrentSelectOption()}
                placeholder="Selecciona un tipo de membresía"
                onChange={(e) =>
                  setFormValues({ ...formValues, idMembresia: parseInt(e.value) })
                }
              />
            </div>
          </div>

          <button className="btn btncrear">Editar</button>
        </form>
      </div>
    </Modal>
  );
};
